module.exports = __webpack_public_path__ + "static/media/19.23946997.jpg";